import React from "react";
import NewPasswordForm from "../form/NewPasswordForm";
import SpravaUctuApi from "../../api/gen/core/SpravaUctuApi";
import * as TwoFactorType from "../../api/gen/core/TwoFactorType";
import { Button, Card, CardBody, Col } from "reactstrap";
import CardTitle from "../layout/CardTitle";
import * as PropTypes from "prop-types";
import SmsConfirmForm from "../form/SmsConfirmForm";
import { SubmissionError } from "redux-form";
import { withLang } from "../../i18n/withLang";
import { i18n } from "../../i18n/i18n";
import { EospPageContent } from "../layout/EospPageContent";
import {brandTitle} from "../../i18n/Message";
const PAGE_STATE_FORM = "PAGE_STATE_FORM";
const PAGE_STATE_DONE = "PAGE_STATE_DONE";
const PAGE_STATE_SMS = "PAGE_STATE_SMS";

class SetPassword extends React.Component<any> {
  constructor(props) {
    super(props);
    this.state = {
      pageState: PAGE_STATE_FORM,
      doklad: null,
      typDokladu: null,
    };
  }

  static propTypes = {
    code: PropTypes.string.isRequired,
    // reset code
    onLoginRedirect: PropTypes.func.isRequired, // akce po nastavení hesla
  };
  changeResettedPasswordSubmit = (code, newPassword, twoFactorCode) => {
    return SpravaUctuApi.changeResettedPassword({ resetCode: code, newPassword: newPassword, firstPassword: false, twoFactorCode: twoFactorCode }).then((resp) => {
      return {
        twoFactorType: resp.twoFactorType,
        twoFactorTypeResponse: resp,
        newPassword,
      };
    });
  };
  changeResettedPasswordSubmitSuccess = (data) => {
    const { twoFactorType, newPassword, twoFactorTypeResponse } = data;

    switch (twoFactorType) {
      case TwoFactorType.NONE:
        this.setState({
          pageState: PAGE_STATE_DONE,
        });
        break;

      case TwoFactorType.SMS:
        this.setState({
          newPassword,
          twoFactorTypeResponse,
          pageState: PAGE_STATE_SMS,
        });
        break;
    }
  };

  render() {
    const { code, onLoginRedirect } = this.props;
    const { twoFactorTypeResponse, pageState } = this.state;

    if (!code) {
      return <div />;
    }

    let content;

    switch (pageState) {
      case PAGE_STATE_FORM:
        content = (
          <NewPasswordForm
            showAgreementForm={false}
            onSubmit={({ newPassword, newPassword_repeat }) => {
              // Async validace - chceme až na tlačítko submit, proto je zde
              if (newPassword !== newPassword_repeat) {
                throw new SubmissionError({
                  _error: i18n(this.props.lang, "Form_HeslaNeshoduji"),
                });
              }

              return this.changeResettedPasswordSubmit(code, newPassword, null);
            }}
            onSubmitSuccess={this.changeResettedPasswordSubmitSuccess}
          />
        );
        break;

      case PAGE_STATE_DONE:
        content = (
          <div>
            <p>{i18n(this.props.lang, "PasswordChangePage_hesloNastaveno")}</p>
            <Button color={"primary"} onClick={onLoginRedirect}>
              {i18n(this.props.lang, "PasswordChangePage_continueLogin")}
            </Button>
          </div>
        );
        break;

      case PAGE_STATE_SMS:
        content = (
          <SmsConfirmForm
            twoFactorTypeResponse={twoFactorTypeResponse}
            onSubmit={({ smsCode }) => {
              return SpravaUctuApi.changeResettedPassword({ resetCode: code, newPassword: this.state.newPassword, firstPassword: false, twoFactorCode: smsCode });
            }}
            onSuccess={(resp) => {
              this.changeResettedPasswordSubmitSuccess(resp);
            }}
          />
        );
        break;
    }

        const title = brandTitle(this.props.lang);

        return <EospPageContent>
            <CardTitle title={title} >
                <h4 className={"font-weight-bold mb-4 sub-title"}>
                    {i18n(this.props.lang, "PasswordChangePage_title")}
                </h4>
            </CardTitle>
            {content}
        </EospPageContent>
    }
}

export default withLang(SetPassword);
